<script setup lang="ts">
import { computed, ref } from 'vue'
import type { VpnAppInstruction } from '@/types'
import { renderInstructionHtml } from '@/utils/sanitizeHtml'

const props = defineProps<{
  instruction: VpnAppInstruction
  appId: number
}>()

const open = ref(false)

const html = computed(() =>
  props.instruction.content ? renderInstructionHtml(props.instruction.content) : '',
)
</script>

<template>
  <div class="apps-accordion-item border border-white-light rounded-lg overflow-hidden">
    <button
      type="button"
      class="flex w-full items-center justify-between gap-2 bg-black/[0.02] px-4 py-3 text-left text-sm font-semibold transition hover:bg-black/[0.04]"
      :aria-expanded="open"
      @click="open = !open"
    >
      <span>{{ instruction.title }}</span>
      <i class="bi shrink-0" :class="open ? 'bi-chevron-up' : 'bi-chevron-down'" />
    </button>
    <div v-show="open" class="border-t border-white-light px-4 py-3">
      <div
        v-if="html"
        class="apps-instruction-body whitespace-pre-wrap break-words text-sm leading-relaxed"
        v-html="html"
      />
    </div>
  </div>
</template>

<style scoped>
.apps-instruction-body :deep(img) {
  max-width: 100%;
  height: auto;
  border-radius: 4px;
}

.apps-instruction-body :deep(a) {
  color: var(--color-primary, #4361ee);
  text-decoration: underline;
  word-break: break-all;
}

.apps-instruction-body :deep(table) {
  width: 100%;
  border-collapse: collapse;
}

.apps-instruction-body :deep(th),
.apps-instruction-body :deep(td) {
  border: 1px solid #e5e7eb;
  padding: 0.35rem 0.5rem;
}
</style>
